export default __webpack_public_path__ + "static/media/authentica-burrito.6b17d99e.jpeg";